<template>
  <nav class="flex flex-col font-semibold">
    <template v-for="(item, index) in sortedItems">
      <router-link
        v-if="item.uri.action == 'app'"
        :key="`item-${index}`"
        v-HoverPrefetchUrl="{ url: item.uri.uri }"
        :to="item.uri.uri[0] === '/' ? item.uri.uri : '/' + item.uri.uri"
        class="navitem flex items-center w-10 px-1 py-2 my-1 text-core-text"
        :style="{ color: item.textColor }"
        :title="cleanAndTranslate(item.title)"
        @click.native="itemClick(item)"
      >
        <div v-if="item.icon" class="w-8 h-8 py-1 px-1 icon flex items-center" :class="item.icon">
          <img v-if="!item.icon.endsWith('.svg')" :src="item.icon" aria-hidden="true" />
          <inline-svg
            v-if="item.icon.endsWith('.svg')"
            :src="item.icon"
            class="fill-current max-w-6 max-h-6 w-6"
            :style="{ fill: item.textColor }"
            aria-hidden="true"
          />
        </div>

        <div v-if="!item.icon" class="w-6 icon icon-default">
          <LocalizeWord :value="item.title"></LocalizeWord>
        </div>

        <div v-if="isTitleVisible" class="icon-title whitespace-no-wrap">
          <LocalizeWord :value="item.title"></LocalizeWord>
        </div>
      </router-link>

      <router-link
        v-if="item.uri.action == 'tiles'"
        :key="`item-${index}`"
        :to="'/tiles/' + item.uri.uri"
        class="navitem flex items-center w-10 px-1 py-2 my-1 text-core-text focus:shadow-outline"
        :style="{ color: item.textColor }"
        :title="cleanAndTranslate(item.title)"
        @click.native="itemClick(item)"
      >
        <div v-if="item.icon" class="w-8 h-8 py-1 px-1 icon flex items-center" :class="item.icon">
          <img v-if="!item.icon.endsWith('.svg')" :src="item.icon" aria-hidden="true" />
          <inline-svg
            v-if="item.icon.endsWith('.svg')"
            :src="item.icon"
            class="fill-current max-w-6 max-h-6 w-6"
            :style="{ fill: item.textColor }"
            alt=""
            aria-hidden="true"
          />
        </div>
        <div v-if="!item.icon" class="w-6 icon icon-default">
          <LocalizeWord :value="item.title"></LocalizeWord>
        </div>
        <div v-if="isTitleVisible" class="icon-title whitespace-no-wrap">
          <LocalizeWord :value="item.title"></LocalizeWord>
        </div>
      </router-link>

      <a
        v-if="item.uri.action == 'blank'"
        :key="`item-${index}`"
        :href="item.uri.uri"
        target="_blank"
        class="navitem flex items-center w-10 px-1 py-2 my-1 text-core-text"
        :style="{ color: item.textColor }"
        :title="cleanAndTranslate(item.title)"
        @click="itemClick(item)"
      >
        <div v-if="item.icon" class="w-8 h-8 py-1 px-1 icon flex items-center" :class="item.icon">
          <img v-if="!item.icon.endsWith('.svg')" :src="item.icon" aria-hidden="true" />
          <inline-svg
            v-if="item.icon.endsWith('.svg')"
            :src="item.icon"
            class="fill-current max-w-6 max-h-6 w-6"
            :style="{ fill: item.textColor }"
            alt=""
            aria-hidden="true"
          />
        </div>
        <div v-if="!item.icon" class="w-6 icon icon-default">
          <LocalizeWord :value="item.title"></LocalizeWord>
        </div>
        <div v-if="isTitleVisible" class="icon-title whitespace-no-wrap">
          <LocalizeWord :value="item.title"></LocalizeWord>
        </div>
      </a>
    </template>
  </nav>
</template>

<script>
import LocalizeWord from "@/components/Shared/LocalizeWord";
import InlineSvg from "vue-inline-svg";
import HoverPrefetchUrl from "@/directives/HoverPrefetchUrl";

export default {
  name: "MenuList",

  props: {
    items: {
      type: Array,
      required: true
    },
    isTitleVisible: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    sortedItems() {
      const sortedItems = this.items;
      return sortedItems.sort((a, b) => a.sort - b.sort);
    }
  },

  methods: {
    cleanAndTranslate(str) {
      const key = str.replace(/({|})/g, "");
      return this.$te(key) ? this.$t(key) : str;
    },

    itemClick(item) {
      this.$emit("itemClick", item);
    }
  },

  components: {
    InlineSvg,
    LocalizeWord
  },

  directives: {
    HoverPrefetchUrl
  }
};
</script>

<style lang="postcss" scoped>
.navitem svg {
  @apply text-black-60% fill-current;
}

.navitem:focus-visible .icon {
  @apply outline-none shadow-outline;
}

.icon-title {
  @apply ml-3;

  @screen md {
    @apply hidden;
  }

  @screen lg {
    @apply block;
  }
}

.icon-default {
  @apply rounded-full bg-primary-core font-light opacity-50 text-center h-6 flex flex-col justify-center;
  font-size: 0;
}

.icon-default ::first-letter {
  @apply text-xs text-white;
}

.sidebar > .nav-container:not(.expanded) a {
  @apply flex items-center;
}

@screen lg {
  .sidebar > .nav-container.expanded .icon {
  }

  .sidebar > .nav-container:not(.expanded) .icon-title {
    @apply opacity-0;
    transition: opacity 0.25s ease;
    transition-delay: 0.25s;
  }

  .sidebar > .nav-container.expanded .icon-title,
  .icon-title {
    @apply opacity-100;
    transition: opacity 0.25s ease;
  }
}
</style>
